import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaVideo } from "react-icons/fa";
import { MdDelete, MdModeEdit, MdPlaylistAdd } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import ModalProcessosLote from "./ModalProcessosLote";



const Processo = (props) => {
  const { t } = usePreferences();

  const [lesson_cards, SetLessonCards] = useState(null);
  const [loading_screen, setLoadingScreen] = useState(true);
  const [loading_processos, setLoadingProcessos] = useState(false);
  const [search_oficial, setSearchOficial] = useState('');

  const [processos, setProcessos] = useState([]);
  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



  const [search, setSearch] = useState('');
  const { faculdade_id, faculdade_name } = props;
  const [show_warning, setShowWarning] = useState(false);
  const [processo_id, setProcessoId] = useState(null);


  const [questaoSelect, setQuestaoSelect] = useState({});

  const [showModal, setShowModal] = useState(false);
  const [showModalLote, setShowModalLote] = useState(false);
  let refs = [];
  const dispatch = useDispatch();

  const user = useSelector((state) => state.AppReducer.user);

  const GetProcessos = async (page, search) => {

    let response = await Request.Get(`faculdade/get_processos/${faculdade_id}?page=${page}&search=${search}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    if (response.pagination.current_page == page) {

      setProcessos(response.processos);

      setPagination(response.pagination);
      setLoadingScreen(false);
      setLoadingProcessos(false);
      props.setState(response.pagination.total_pages);


    }
  };

  const DeleteProcesso = async (processo_id) => {

    let response = await Request.Delete(`faculdade/delete_processo/${processo_id}`);
    console.log(response);
    if (response === undefined) return;

    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    GetProcessos(pagination.current_page, search_oficial);



  };

  useEffect(() => {
    GetProcessos(1, search_oficial);
  }, []);

  let pesquisarTimeout = null;
  const history = useHistory();
  const backToDashboard = () => {
    console.log('entrou aqui')
    props.setStateTab({
      activeTab: -1
    })
    history.push({
      search: ''
    });
  };

  return (
    <>

      <>


        {/* <hr /> */}
        {loading_screen == false && <div className="module-card-container">

          <div className="module-breadcrumb">

            <button
              className="breadcrumb-back"
              onClick={backToDashboard}>{t("dashboard")}


            </button>

            <span>/</span>

            <strong>
              {user.empresa == null || user.empresa.change_text == false ? t("title_process") : t("vacancies")

              }
            </strong>

          </div>

          <div className="module-title-row">

            <div>

              <h3 style={{ fontWeight: 'bold' }}>
                {user.empresa == null || user.empresa.change_text == false ? t("title_process") : t("vacancies")

                }
              </h3>

              <p>
                {user.empresa == null || user.empresa.change_text == false ? t("legacy_gerencie_os_processos_vinculados_a_instituicao") : t("legacy_gerencie_as_vagas_vinculadas_ao_seletivo")

                }

              </p>

            </div>

            <button
              className="btn-dashboard-modern"
              onClick={backToDashboard}>{`
                            ${t("legacy_dashboard")}
                        `}
            </button>



          </div>

          <div className="module-toolbar">

            <Search
              placeholder={
                t("placeholder_search_by_name") + " " + (
                  user.empresa == null || user.empresa.change_text == false ? t("legacy_do_processo") :

                    t("label_of_vacancy_position"))
              }
              ValueChange={(value) => {

                clearTimeout(pesquisarTimeout);

                setSearchOficial(value);

                pesquisarTimeout = setTimeout(() => {

                  let page = { ...pagination };

                  page.current_page = 1;

                  setPagination(page);

                  setLoadingProcessos(true);

                  GetProcessos(1, value);

                }, 500);

              }} />

            {(user.role == 'region_admin' || user.empresa == null || user.empresa.can_add) &&

              <div style={{justifyContent:'end',display:'flex',flexWrap:'wrap'}}>
                <button
                  type="button"
                  className="btn-module-secondary btn-module-bulk"
                  style={{marginRight:2}}
                  onClick={() => setShowModalLote(true)}>

                  <MdPlaylistAdd />
                  {user.empresa == null || user.empresa.change_text == false ? t("bulk_process_add_button") : t("bulk_vacancy_add_button")}
                </button>

                <Link
                  to={`/processos/register/${faculdade_id}`}
                  className="btn-module-primary">

                  <FaListAlt />{`

                  ${t("action_add")} `}{user.empresa == null || user.empresa.change_text == false ? t("process") : t("vacancy")

                  }
                </Link>
              </div>

            }

          </div>

          <div className="table-modern-card">

            <table
              id="tech-companies-1"
              className="table table-striped">


              <thead>

                <tr>

                  <th>{t("label_name")}</th>

                  <th>{t("label_start")}</th>

                  <th>{t("label_end")}</th>

                  <th>{t("label_actions")}</th>

                </tr>

              </thead>

              <tbody>

                {!loading_processos && processos.map((item, id) =>

                  <tr key={id}>

                    <td>

                      <strong>
                        {item.name}
                      </strong>

                    </td>

                    <td>

                      {moment(item.inicio).
                        format('DD/MM/YYYY HH:mm')}

                    </td>

                    <td>

                      {moment(item.fim).
                        format('DD/MM/YYYY HH:mm')}

                    </td>

                    <td>

                      <div className="actions-group">

                        <Link
                          to={`/processos/show/${item.id}`}>

                          <button
                            className="action-btn warning"
                            title={t("legacy_visualizar")}>

                            <BsFillEyeFill />
                          </button>
                        </Link>

                        {(user.role == 'region_admin' ||
                          user.empresa == null || user.empresa.can_edit) &&

                          <Link
                            to={`/processos/edit/${item.id}`}>

                            <button
                              className="action-btn info"
                              title={t("edit")}>

                              <MdModeEdit />
                            </button>
                          </Link>

                        }

                        {(user.role == 'region_admin' ||
                          user.empresa == null || user.empresa.can_exclude) &&

                          <button
                            className="action-btn danger"
                            title={t("action_delete")}
                            onClick={() => {

                              setProcessoId(item.id);

                              setShowWarning(true);

                            }}>

                            <MdDelete />
                          </button>

                        }

                      </div>

                    </td>

                  </tr>

                )}

              </tbody>

            </table>

            {loading_processos &&

              <div className="row m-0">

                <div className="col-12 d-flex justify-content-center align-items-center">

                  <CircularProgress />

                </div>

              </div>

            }

          </div>

          {!loading_processos && processos.length === 0 &&

            <div className="empty-module">

              <div className="empty-module-icon">
                📋
              </div>

              <h3>
                {user.empresa == null || user.empresa.change_text == false ?
                  t("empty_no_process_found") :
                  t("empty_no_vacancy_found")}
              </h3>

              <p>
                {user.empresa == null || user.empresa.change_text == false ?
                  t("empty_register_first_process") :
                  t("empty_register_first_vacancy")}
              </p>

            </div>

          }

          <Pagination
            className={
              pagination.last_page === 1 ?
                "hide" :
                ""
            }
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px"
            }}
            count={pagination.last_page}
            value={pagination.current_page}
            onChange={(_, value) => {

              setLoadingProcessos(true);

              let page = { ...pagination };

              page.current_page = value;

              setPagination(page);

              GetProcessos(
                value,
                search_oficial
              );

            }} />


        </div>}

        {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
          {/* <div className="spinner-border text-primary" role="status"  >
              </div> */}
          <CircularProgress />
        </div></div>}

        <SweetAlert
          warning
          title={t("legacy_atencao")}
          onConfirm={() => {
            setShowWarning(false);
            setLoadingProcessos(true);
            DeleteProcesso(processo_id);
            // this.delete_banner(this.state.banner_to_delete);
          }}
          onCancel={() => {
            setShowWarning(false);
          }}
          show={show_warning}
          confirmBtnText={t("legacy_sim_desejo_apagar")}
          cancelBtnText={t("legacy_cancelar")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          showCancel={true}>{t("ui_ao_deletar_este_processo_ele_nao_estara_mais_dispo_d822045c")}


        </SweetAlert>

        <ModalProcessosLote
          showModal={showModalLote}
          setShowModal={setShowModalLote}
          faculdadeId={faculdade_id}
          changeText={user.empresa != null && user.empresa.change_text == true}
          onFinish={() => GetProcessos(pagination.current_page, search_oficial)}
        />

      </>

    </>);

};

export default Processo;
